import { OrganisationUnitDetail } from './OrganisationUnitDetail';
import React, { useContext } from 'react';
import { TmsContext } from '../TmsContext';
import { TenantHierarchyTree } from '../components/TenantHierarchyTree';
import { ComponentErrorBoundary } from '@app/utilities';
import { Error } from '@app/shared';
import { useOrganisationHierarchy } from '@app/sdk';
import { SideListHeader } from '../components/ListHeader';
import { MasterDetailLayout } from '../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';

export function TenantHierarchy() {
  const { selectedOu } = useContext(TmsContext);
  const { isLoading, error, data: organisationHierarchy } = useOrganisationHierarchy();

  const master = (
    <Segment>
      <SideListHeader>Tenant OU Hierarchy</SideListHeader>
      <TenantHierarchyTree organisationHierarchy={organisationHierarchy} />
    </Segment>
  );

  const detail = (
    <>
      <Segment>
        {!selectedOu && <section>Please select an Organisation Unit</section>}
        <OrganisationUnitDetail selectedOu={selectedOu} />
      </Segment>
    </>
  );
  return (
    <ComponentErrorBoundary>
      {error && <Error error={error} />}
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && organisationHierarchy && (
        <MasterDetailLayout master={master} detail={detail} masterWidth={'four'} detailWidth={'twelve'} />
      )}
    </ComponentErrorBoundary>
  );
}
